/**
 * Converts an object of parameters into a query string format.
 * @param {Object} params - The parameters to convert.
 * @returns {string} - The query string representation of the parameters.
 */
export const getParams = (params) => {
    return Object.entries(Object.assign({}, params)).map(([key, value]) => `${key}=${value}`).join('&');
};